export default "__VITE_ASSET__ce37dd2e__"